import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Link } from 'react-router-dom';
import { Quote, ChevronLeft, ChevronRight } from 'lucide-react';
const testimonials = [{
  name: 'Paul Manudat',
  text: "NWBBA Lynnwood, this is one place we call a Home away from home! One of the main reasons is because of Master Joe. He has welcomed our family into this Dojang with open arms and has made us feel like family from the very first moment we entered the school.\n\nMy son Anthony, has been training with Coach Brandon, Master Joe and Master Kevin and loves Taekwondo and the sparring team. He rarely every misses a class and is always excited to go. The variety of workouts you get will keep your heart pumping, wear you out and make you want more.\n\nThis place is number one in my book. The changes in my son's general attitude & performance are significant & noticeable. Mrs. Maria is jet ski office and is a miracle worker, she handles most of if not all the paper work, registration, fundraising, billing. You got questions, she has Answers.\n\nBottom line: This is a Great School to be educated. Come join the family, you won't regret it!"
}, {
  name: 'Ruchi Paul',
  text: "Our 11 year old son started training in Taekwondo at the Northwest Black Belt Academy (NWBBA) almost one year ago. We soon realized that there was a vast difference between Martial art clubs & pro-grade comprehensive martial arts education center like NWBBA.\n\nMaster Joe and the team of instructors & assistants are serious professionals who are dedicated to developing competitive, well rounded and disciplined athletes of the future. They pay meticulous attention to detail on every student's individual performance and work closely with them to bring out their best.\n\nThe support staff at NWBBA are caring, kind and helpful. The changes in my son's general attitude & performance are significant & noticeable. We highly recommend NWBBA to all aspiring martial artists!"
}, {
  name: 'Marianne Pedigan',
  text: 'My daughter has been taking Taekwondo for 6 years. She started at another school but just recently moved to NWBBA with Master Joe Whitworth and his outstanding team of instructors.\n\nIn the short time we have been here, we have been impressed with the caliber of expert instruction our daughter has received. She is excited to learn taekwondo again. She was three weeks away from getting her black belt before we moved schools, but she insists that this was the best decision we have made.\n\nShe is eager to earn her black belt from Master Joe. She has learned so much and loves it. I am grateful. Master Joe is a great teacher and a wonderful role model. I would recommend this school to anyone. They invest in every penny.'
}, {
  name: 'Eric Miller',
  text: 'NWBBA, is a great place for Taekwondo. Master Joe is an amazing role model and Instructors. It is a great place for kids and adults alike.\n\nThe discipline and respect that is taught and practiced by the kids is exceptional. Both teachers and parents from school recognize and comment about how polite, courteous, and respectful my daughter is. She stays focused and on task daily and I believe it is from the tenants that are taught at NWBBA.\n\nWe love the place and would not take our kids anywhere else. We would highly recommend anyone else.'
}];
const fadeIn = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6
    }
  }
};
const slideVariants = {
  enter: (direction: number) => ({
    x: direction > 0 ? 1000 : -1000,
    opacity: 0
  }),
  center: {
    zIndex: 1,
    x: 0,
    opacity: 1
  },
  exit: (direction: number) => ({
    zIndex: 0,
    x: direction < 0 ? 1000 : -1000,
    opacity: 0
  })
};
interface ProofSectionProps {
  testimonialIndex?: number;
}
export function ProofSection({
  testimonialIndex
}: ProofSectionProps) {
  const isSingleTestimonial = testimonialIndex !== undefined;
  const [currentIndex, setCurrentIndex] = useState(testimonialIndex ?? 0);
  const [direction, setDirection] = useState(0);
  // Auto-rotate testimonials when in single testimonial mode
  useEffect(() => {
    if (isSingleTestimonial) {
      const timer = setInterval(() => {
        paginate(1);
      }, 8000); // Change every 8 seconds
      return () => clearInterval(timer);
    }
  }, [currentIndex, isSingleTestimonial]);
  const paginate = (newDirection: number) => {
    setDirection(newDirection);
    setCurrentIndex(prevIndex => {
      const nextIndex = prevIndex + newDirection;
      if (nextIndex < 0) return testimonials.length - 1;
      if (nextIndex >= testimonials.length) return 0;
      return nextIndex;
    });
  };
  // Format text with paragraph breaks
  const formatText = (text: string) => {
    return text.split('\n\n').map((paragraph, idx) => <p key={idx} className="text-gray-200 leading-relaxed mb-4 last:mb-0" data-id="element-143">
        {paragraph}
      </p>);
  };
  if (isSingleTestimonial) {
    return <section className="py-20 px-4 bg-[#0f1f3d]" data-id="element-144">
        <div className="max-w-6xl mx-auto" data-id="element-145">
          <div className="text-center mb-16" data-id="element-146">
            <motion.div initial="hidden" whileInView="visible" viewport={{
            once: true
          }} variants={fadeIn} data-id="element-147">
              <h2 className="text-3xl sm:text-4xl md:text-5xl font-black text-white mb-4" data-id="element-148">
                What Parents Say
              </h2>
              <div className="w-24 h-1 bg-[#a3d977] mx-auto rounded-full mb-6" data-id="element-149"></div>
              <p className="text-gray-300 text-lg max-w-2xl mx-auto" data-id="element-150">
                Real stories from real families who've experienced the NWBBA
                difference.
              </p>
            </motion.div>
          </div>

          {/* Rotating Testimonial Carousel */}
          <div className="relative max-w-4xl mx-auto" data-id="element-151">
            <AnimatePresence initial={false} custom={direction} mode="wait" data-id="element-152">
              <motion.div key={currentIndex} custom={direction} variants={slideVariants} initial="enter" animate="center" exit="exit" transition={{
              x: {
                type: 'spring',
                stiffness: 300,
                damping: 30
              },
              opacity: {
                duration: 0.2
              }
            }} className="bg-white/5 backdrop-blur-sm p-8 md:p-12 rounded-xl border-2 border-[#a3d977]/20" data-id="element-153">
                <Quote className="w-10 h-10 text-[#a3d977] mb-6" data-id="element-154" />
                <div className="text-base" data-id="element-155">
                  {formatText(testimonials[currentIndex].text)}
                </div>
                <div className="pt-6 mt-6 border-t border-white/10" data-id="element-156">
                  <p className="font-bold text-white text-lg" data-id="element-157">
                    {testimonials[currentIndex].name}
                  </p>
                  <p className="text-gray-400 text-sm mt-1" data-id="element-158">NWBBA Parent</p>
                </div>
              </motion.div>
            </AnimatePresence>

            {/* Navigation Arrows */}
            <button onClick={() => paginate(-1)} className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-4 md:-translate-x-12 p-3 bg-white/10 hover:bg-white/20 rounded-full border-2 border-[#a3d977]/30 transition-colors" aria-label="Previous testimonial" data-id="element-159">
              <ChevronLeft className="w-6 h-6 text-white" data-id="element-160" />
            </button>
            <button onClick={() => paginate(1)} className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-4 md:translate-x-12 p-3 bg-white/10 hover:bg-white/20 rounded-full border-2 border-[#a3d977]/30 transition-colors" aria-label="Next testimonial" data-id="element-161">
              <ChevronRight className="w-6 h-6 text-white" data-id="element-162" />
            </button>

            {/* Dots Indicator */}
            <div className="flex justify-center gap-2 mt-8" data-id="element-163">
              {testimonials.map((_, idx) => <button key={idx} onClick={() => {
              setDirection(idx > currentIndex ? 1 : -1);
              setCurrentIndex(idx);
            }} className={`w-2 h-2 rounded-full transition-all ${idx === currentIndex ? 'bg-[#a3d977] w-8' : 'bg-white/30 hover:bg-white/50'}`} aria-label={`Go to testimonial ${idx + 1}`} data-id="element-164" />)}
            </div>
          </div>

          <motion.div initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.5
        }} className="text-center mt-12" data-id="element-165">
            <Link to="/proof" className="inline-block px-8 py-4 bg-white text-[#0f1f3d] text-lg font-bold rounded-lg shadow-lg hover:bg-gray-100 transition-colors border-2 border-[#a3d977]/30" data-id="element-166">
              Read More Success Stories
            </Link>
          </motion.div>
        </div>
      </section>;
  }
  // Full testimonials grid (for Proof page)
  const displayTestimonials = testimonials.concat([{
    name: 'Satori Seraier',
    text: 'Through NWBBA, I have gained several strengths, including schedule prioritization and a respectful nature. Including these, my physical strengths have extremely exceeded my original expectations of myself.\n\nEmotional intelligence, although unexpected, has also contributed to my performance at NWBBA. All in all, these points contribute at the friendly and productive atmosphere you are immediately surrounding in when entering the dojang.'
  }, {
    name: 'Kristina Allen',
    text: 'NWBBA has become a home away from home for my family. My daughter is on the competition team, that Master Joe coaches and it has become such a big part of her life.\n\nMaster Joe and the other instructors know how to motivate, connect, encourage and make our kids better athletes and better human beings. We are so fortunate to have found NWBBA in Lynnwood. Kudos to Master Joe for creating a great program and great environment for our kids!'
  }]);
  return <section className="py-20 px-4 bg-[#0f1f3d]" data-id="element-167">
      <div className="max-w-6xl mx-auto" data-id="element-168">
        <div className="text-center mb-16" data-id="element-169">
          <motion.div initial="hidden" whileInView="visible" viewport={{
          once: true
        }} variants={fadeIn} data-id="element-170">
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-black text-white mb-4" data-id="element-171">
              Proof
            </h2>
            <div className="w-24 h-1 bg-[#a3d977] mx-auto rounded-full mb-6" data-id="element-172"></div>
            <p className="text-gray-300 text-lg max-w-2xl mx-auto" data-id="element-173">
              Real stories from real families who've experienced the NWBBA
              difference.
            </p>
          </motion.div>
        </div>

        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-174">
          {displayTestimonials.map((testimonial, idx) => <motion.div key={idx} variants={fadeIn} className="bg-white/5 backdrop-blur-sm p-8 rounded-xl border-2 border-[#a3d977]/20 hover:border-[#a3d977]/40 transition-colors" data-id="element-175">
              <Quote className="w-10 h-10 text-[#a3d977] mb-6" data-id="element-176" />
              <div className="text-base mb-6" data-id="element-177">
                {formatText(testimonial.text)}
              </div>
              <div className="pt-6 border-t border-white/10" data-id="element-178">
                <p className="font-bold text-white text-lg" data-id="element-179">
                  {testimonial.name}
                </p>
                <p className="text-gray-400 text-sm mt-1" data-id="element-180">NWBBA Parent</p>
              </div>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}